//
//
//
//
//
//
//
//
//

export default {
  props: {
    link: String,
    buttonText: String,
    leftAlign: {
      type: Boolean,
      default: false
    }
  }
}
